import { useQuery, QueryResult } from '@eika-infrastruktur/react-query';

import { RegulatoryCode } from '../generated-types';
import { getRegulatoryCodes } from '../services/banksService';

export const useRegulatoryCodes = (): QueryResult<RegulatoryCode[]> =>
    useQuery({
        queryKey: ['regulatory-codes'],
        queryFn: getRegulatoryCodes,
        staleTime: Infinity,
    });
